import { State } from "../index";
import { createSelector } from "reselect";

const getUserState = (state: State) => state.user;

export const getUser = createSelector([getUserState], (state) => state.user);

export const selectors = {
  user: getUser,
};
